import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "@/App";
import { HeroCarousel } from "@/components/HeroCarousel";
import { HeroSection, RichTextSection, ImageTextSection, CtaSection, VideoSection, EmbedSection, Wrap } from "@/website/sections/Basic";
import { CardsSection, GallerySection, TestimonialsSection, FaqSection, DownloadsSection } from "@/website/sections/Lists";
import { ContactSection, BookingSection } from "@/website/sections/Contact";
import { FilesSection, AudioSection, LinksSection } from "@/website/sections/Media";
import { FeatureCardsGrid } from "@/components/FeatureCardsGrid";

const PlatformHero = ({ testId }) => {
  const [hp, setHp] = useState(null);
  useEffect(() => { axios.get(`${API}/settings/homepage`).then((r) => setHp(r.data)).catch(() => setHp({})); }, []);
  const slides = hp?.hero_slides?.length ? hp.hero_slides : [{ id: "default", url: hp?.hero_image || "/hero.jpg", type: hp?.hero_media_type || "image" }];
  return (
    <Wrap testId={testId}>
      <div className="flex flex-wrap justify-center gap-3 mb-8">
        {[["/worksheet-generator", "Abacus Worksheet Generator"], ["/login", "MathBot - AI Maths Tutor"], ["/play/arena", "Times Tables Arena"]].map(([to, label]) => (
          <Link key={to} to={to} className="rounded-full border border-slate-300 px-5 h-11 inline-flex items-center font-medium hover:border-[var(--site-primary)] hover:text-[var(--site-primary)] transition-colors">{label}</Link>
        ))}
      </div>
      {hp && <HeroCarousel slides={slides} interval={hp.hero_interval || 5} onOpen={() => {}} />}
    </Wrap>
  );
};

const ColumnsSection = ({ d, testId }) => (
  <Wrap testId={testId}>
    <div className={`grid gap-8 ${["", "md:grid-cols-1", "md:grid-cols-2", "md:grid-cols-3", "md:grid-cols-4"][Math.min((d.columns || []).length, 4)]}`}>
      {(d.columns || []).map((c, i) => <div key={i} className="min-w-0 [&_section]:py-0 [&_section>div]:px-0">{(c.sections || []).map((s) => <Section key={s.id} s={s} />)}</div>)}
    </div>
  </Wrap>
);

const FeatureCardsSection = ({ d, testId }) => (
  <Wrap testId={testId}><FeatureCardsGrid headingOverride={d.heading} subheadingOverride={d.subheading} /></Wrap>
);

const MAP = {
  hero: HeroSection, platform_hero: PlatformHero, rich_text: RichTextSection, image_text: ImageTextSection, cards: CardsSection,
  gallery: GallerySection, video: VideoSection, testimonials: TestimonialsSection, faq: FaqSection, downloads: DownloadsSection,
  cta: CtaSection, contact: ContactSection, booking: BookingSection, embed: EmbedSection, columns: ColumnsSection,
  files: FilesSection, audio: AudioSection, links: LinksSection, feature_cards: FeatureCardsSection,
};

export const Section = ({ s }) => {
  const C = MAP[s.type];
  if (!C || s.visible === false) return null;
  return <div id={s.data?.anchor || undefined}><C d={s.data || {}} testId={`site-section-${s.id}`} /></div>;
};

export const SectionList = ({ sections = [] }) => sections.map((s) => <Section key={s.id} s={s} />);
